import React from 'react';
import BlurredDataChip from './BlurredDataChip';
import Link from 'next/link';
import { NumberOfHiringPartners, SalariesData } from '@lib/constants';

const SuccessStoriesHero = ({ DownloadPlacementReport }) => {
  const chipData = {
    chip1: {
      title: 'Students Placed',
      data: '3000+',
    },
    chip2: {
      title: 'Average Package',
      // data: '8 LPA',
      data: SalariesData.averageSalary,
    },
    chip3: {
      title: 'Salary Hike',
      data: '50%',
    },
    chip4: {
      title: 'Hiring Partners',
      // data: '700+',
      data: NumberOfHiringPartners + '+',
    },
  };

  return (
    <div className="relative flex flex-col items-center justify-center overflow-hidden bg-black py-16 px-8 text-center text-white md:h-[90vh] md:py-0 md:px-0">
      <img
        src="assets/images/Placement Statistics/Success Stories/Dot grid.svg"
        alt=""
        className="absolute inset-0  h-full w-full opacity-10"
        draggable="false"
      />
      <img
        src="assets/images/Placement Statistics/Success Stories/SuccessStories-Hero-Image2.svg"
        alt=""
        className="absolute left-0 top-8 bottom-0  w-[32%] md:w-auto"
        draggable="false"
      />
      <img
        src="assets/images/Placement Statistics/Success Stories/SuccessStories-Hero-Image1.svg"
        alt=""
        className=" absolute right-0 bottom-[50%] w-[32%] md:bottom-0 md:w-auto "
        draggable="false"
      />
      <div className="flex flex-col gap-y-8">
        <p className=" font-satoshi-bold text-4xl font-bold  md:text-6xl ">
          Success <u className=" text-red">Stories</u>
        </p>
        <p className=" font-satoshi-medium text-xs text-gray-subtitle md:text-lg">
          Our learners are the centre of our universe. We take a lot of pride in their journey.
          <br />
          These stories and testimonials fuel our ambitions at AlmaBetter.
        </p>
        <div className="mt-4 flex w-full flex-wrap justify-center gap-4">
          <Link href={'/courses'} as={'/courses'} passHref>
            <a className="center btn-red z-20 w-4/5 cursor-pointer font-satoshi-medium font-semibold md:w-fit">
              Explore Our Courses
            </a>
          </Link>
          {DownloadPlacementReport && (
            <DownloadPlacementReport
              style={'rounded-lg px-4 py-3 text-center text-gray-600 w-4/5 md:w-fit'}
            />
          )}
        </div>
        <BlurredDataChip chipData={chipData} />
      </div>
    </div>
  );
};

export default SuccessStoriesHero;
